export default "__VITE_ASSET__1963f040__"